import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import secureLocalStorage from "react-secure-storage";
import { constants } from '../constants.js';
import { userSlice } from './userSlice.js';
import { categorySlice } from './categorySlice.js';
import { cartSlice } from './cartSlice.js';

export const mergePersistedUserState = (persisted, current) => ({
    ...current,
    mobileDevice: typeof persisted?.mobileDevice === 'boolean'
        ? persisted.mobileDevice
        : current.mobileDevice
});

export const mergePersistedCartState = (persisted, current) => ({
    ...current,
    items: Array.isArray(persisted?.items)
        ? persisted.items.filter((item) => item?.itemType === 'combo')
        : []
});

const mySlices = [
    {
        slice: userSlice,
        // Authentication, wallet and user data must always come from /user.
        // Only the non-private responsive preference is safe to restore.
        partialize: ({ mobileDevice }) => ({ mobileDevice }),
        merge: mergePersistedUserState
    },
    { slice: categorySlice },
    {
        slice: cartSlice,
        // Combos are a local, visual-only cart. Product cart lines belong to
        // the authenticated server user and are deliberately not cached.
        partialize: ({ items }) => ({
            items: Array.isArray(items)
                ? items.filter((item) => item?.itemType === 'combo')
                : []
        }),
        merge: mergePersistedCartState
    }
];

const initGoldStore = () => {
    const myStore = {};
    mySlices.forEach(({ slice, partialize, merge }, myIndex) => {
        const storeCreated = create(
            persist(
                slice,
                {
                    name: constants.KEY_STORAGE_BASE + myIndex,
                    storage: createJSONStorage(() => secureLocalStorage),
                    ...(partialize ? { partialize } : {}),
                    ...(merge ? { merge } : {})
                }
            )
        )
        const sliceName = ['userSlice', 'categorySlice', 'cartSlice'][myIndex];
        Object.assign(myStore, {...myStore, [sliceName]: storeCreated});
    });
    return myStore;
}

const goldStore = initGoldStore();

export const getUserSlice = goldStore.userSlice;
export const getCategorySlice = goldStore.categorySlice;
export const getCartSlice = goldStore.cartSlice;
